import * as React from "react"
import PhoneInputOriginal from "react-phone-number-input"
import "react-phone-number-input/style.css"
import { cn } from "../../../lib/utils"

export type PhoneInputProps = React.ComponentProps<typeof PhoneInputOriginal> & {
  className?: string
  error?: boolean
  placeholder?: string
}

// Custom styling to match the project's Input component
// We target the classes generated by react-phone-number-input
const PhoneInput = React.forwardRef<any, PhoneInputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <>
        <style>{`
          .PhoneInput {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }
          .PhoneInputCountry {
            position: relative;
            display: flex;
            align-items: center;
            align-self: stretch;
            flex-shrink: 0;
            margin-right: 0.5rem;
          }
          .PhoneInputCountrySelect {
            appearance: none;
            background-color: transparent;
            border: none;
            color: inherit;
            font: inherit;
            /* The native select is usually overlaid with opacity 0 by the library, but let's ensure it's not display:none */
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            z-index: 1;
            opacity: 0;
            cursor: pointer;
          }
           /* Customizing the Country Select Arrow/Icon container if needed */
          .PhoneInputCountryIcon {
            width: 1.5rem;
            height: 1.5rem;
            border-radius: 0.125rem;
            overflow: hidden;
            box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
          }
          .PhoneInputCountryIcon--border {
             box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
          }
          .PhoneInputCountrySelectArrow {
             margin-left: 0.3rem;
             border-color: currentColor;
             border-top-width: 1px;
             border-right-width: 1px;
             transform: rotate(45deg);
             width: 0.5em;
             height: 0.5em;
             opacity: 0.5;
          }
          
          /* The actual input field */
          .PhoneInputInput {
            flex: 1;
            min-width: 0;
            height: 100%;
            background-color: transparent;
            font-size: 0.875rem; /* text-sm */
            line-height: 1.25rem;
            font-weight: 900; /* font-black */
            outline: none;
            border: none;
          }
          
           /* Use a wrapper class to apply standard Input styles to the container if we want
              OR apply them to the internal input. 
              The standard Input styles usually apply to the <input> element itself.
              But here we have a composite component.
           */
        `}</style>

        <PhoneInputOriginal
          ref={ref}
          className={cn(
            // Matches the Input component base styles but applied to the wrapper or input
            "flex h-12 w-full rounded-[18px] border border-[1.5px] border-input bg-transparent px-4 py-1 text-sm font-black transition-[color,border-radius] file:border-0 file:bg-transparent file:text-sm file:font-black placeholder:text-muted-foreground/60 focus-within:outline-none focus-within:ring-[3px] focus-within:ring-ring/50 focus-within:border-ring disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-destructive focus-within:ring-destructive/20",
            className
          )}
          numberInputProps={{
            className: "bg-transparent border-none focus:outline-none placeholder:text-muted-foreground/60 text-sm w-full h-full font-black",
          }}
          defaultCountry="GB"
          countries={["GB"]}
          {...props}
          onChange={props.onChange}
        />
      </>
    )
  }
)

PhoneInput.displayName = "PhoneInput"

export { PhoneInput }
